// 278 in array as of 19.04
export const CHARACTERS_MAP = [
  126, 245, 1, 227, 106, 142, 73, 31, 24, 168, 56, 42, 60, 154, 117, 230, 195,
  215, 135, 153, 186, 8, 81, 184, 196, 75, 58, 122, 79, 80, 52, 149, 98, 70,
  173, 85, 144, 63, 50, 225, 129, 187, 217, 151, 167, 228, 136, 132, 183, 220,
  229, 111, 109, 28, 118, 51, 78, 113, 165, 62, 176, 242, 175, 171, 121, 157,
  178, 2, 138, 119, 182, 180, 25, 159, 216, 243, 137, 57, 226, 201, 18, 223,
  247, 46, 19, 41, 22, 172, 202, 43, 67, 66, 200, 105, 74, 104, 177, 82, 101,
  68, 71, 210, 6, 205, 162, 150, 239, 112, 16, 169, 11, 9, 193, 23, 158, 102,
  146, 32, 64, 107, 231, 4, 44, 164, 87, 7, 5, 190, 61, 47, 84, 232, 86, 212,
  40, 103, 96, 59, 48, 26, 147, 88, 53, 17, 141, 207, 114, 55, 65, 160, 174,
  192, 222, 234, 69, 45, 3, 241, 170, 130, 92, 35, 36, 120, 97, 123, 143, 208,
  27, 29, 211, 155, 185, 15, 38, 145, 237, 218, 189, 34, 10, 131, 156, 115, 39,
  90, 94, 13, 93, 125, 206, 179, 140, 148, 127, 116, 191, 238, 198, 240, 188,
  166, 235, 77, 214, 54, 33, 83, 236, 72, 76, 244, 124, 203, 209, 99, 108, 37,
  219, 110, 152, 20, 181, 30, 194, 221, 95, 199, 246, 233, 224, 139, 14, 161,
  197, 133, 204, 12, 49, 213, 91, 163, 134, 128, 100, 21, 89, 0,
];
// 130 in array as of 25.04
export const QUOTES_MAP = [
  36, 7, 38, 28, 37, 53, 39, 40, 73, 71, 66, 32, 69, 2, 0, 41, 59, 11, 6, 57,
  61, 23, 80, 64, 8, 3, 17, 93, 40, 50, 119, 16, 51, 33, 86, 23, 59, 94, 53,
  129, 10, 34, 98, 1, 72, 46, 4, 95, 44, 65, 121, 68, 87, 30, 62, 25, 38, 6, 90,
  20, 47, 91, 15, 54, 128, 113, 96, 102, 11, 36, 18, 105, 101, 45, 14, 80, 115,
  37, 63, 109, 29, 74, 35, 122, 43, 73, 52, 32, 48, 12, 5, 84, 88, 70, 71,
  76, 42, 13, 75, 120, 111, 39, 77, 24, 67, 9, 92, 41, 0, 69, 49, 78, 106, 116,
  7, 26, 97, 57, 61, 83, 85, 108, 107, 81, 117, 114, 112, 58, 110, 103, 66, 79,
  124, 31, 60, 125, 28, 64, 126, 2, 21, 82, 104, 118, 22, 19, 56, 123, 127, 55,
  99, 27, 89, 8, 11, 62, 73, 97, 87, 13, 102, 18, 35, 105, 85, 4, 16, 3, 36, 96,
  112, 38, 82, 90, 63, 2, 114, 24, 57, 22, 67, 64, 101, 76, 89, 42, 120, 5, 12,
  45, 48, 43, 106, 34, 46, 78, 86, 26, 19, 44, 14, 123, 1, 28, 41, 104, 79, 21,
  30, 66, 98, 61, 84, 115, 10, 49, 91, 53, 113, 55, 83, 52, 51, 27, 95, 69, 92,
  118, 81, 72, 127, 117, 74, 60, 20, 25, 58, 124, 29, 31, 23, 54, 9, 17,
  50, 59, 108, 56, 65, 93, 116, 119, 40, 103, 109, 39, 94, 47, 32, 68, 99, 122,
  121, 8, 75, 70, 111, 110, 125, 129, 37, 107, 71, 88, 33, 6, 126, 0, 77, 7,
  128, 15, 80,
];
// 129 in array as of 24.04
export const MUSIC_MAP = [
  36, 7, 38, 28, 37, 53, 39, 40, 73, 71, 66, 32, 69, 2, 0, 41, 59, 11, 6, 57,
  61, 23, 80, 64, 8, 74, 73, 122, 42, 79, 31, 108, 20, 2, 68, 58, 0, 97, 61, 72,
  103, 94, 29, 88, 41, 6, 112, 89, 116, 117, 45, 86, 4, 38, 48, 77, 8, 47, 125,
  32, 114, 10, 54, 113, 85, 21, 121, 56, 70, 26, 93, 35, 3, 124, 126, 1, 98,
  101, 15, 44, 118, 52, 83, 106, 53, 40, 91, 87, 102, 81, 128, 96, 27, 66, 67,
  63, 51, 34, 9, 55, 99, 80, 111, 16, 25, 110, 49, 13, 104, 28, 36, 37, 119, 76,
  59, 115, 62, 69, 60, 120, 7, 105, 95, 100, 11, 71, 109, 33, 57, 17, 75, 50, 5,
  107, 92, 19, 90, 64, 30, 46, 43, 18, 39, 23, 84, 127, 123, 14, 24, 12, 78, 65,
  22, 6, 116, 115, 27, 51, 70, 24, 41, 34, 5, 47, 50, 118, 16, 28, 9, 23, 43,
  66, 108, 87, 114, 21, 105, 60, 38, 3, 101, 26, 103, 95, 127, 76, 1, 91, 48,
  81, 14, 124, 75, 61, 56, 72, 90, 82, 58, 15, 92, 19, 99, 49, 107, 46, 119, 17,
  121, 59, 69, 89, 53, 112, 126, 25, 33, 42, 31, 0, 125, 44, 18, 4, 22, 123,
  106, 102, 111, 35, 52, 88, 29, 83, 120, 128, 64, 63, 68, 39, 78, 98, 71, 113,
  54, 84, 13, 97, 7, 30, 62, 20, 32, 80, 12, 2, 45, 55, 10, 93, 109, 122, 11,
  86, 57, 96, 77, 85, 79, 36, 8, 65, 74, 104, 117, 73, 67, 40, 100, 94, 110, 37,
];
// 86 in array as of 25.05
export const LOCATIONS_MAP = [
  2, 45, 9, 24, 23, 54, 4, 10, 46, 8, 42, 38, 40, 25, 31, 49, 17, 35, 30, 21,
  44, 29, 18, 52, 0, 12, 47, 34, 19, 16, 51, 56, 37, 50, 14, 15, 33, 43, 6, 5,
  22, 27, 55, 41, 3, 36, 7, 26, 57, 11, 48, 39, 53, 32, 20, 13, 41, 23, 70, 61, 35, 29, 39, 24, 59, 4, 75, 25, 19, 45, 2, 33, 67, 26, 9, 28,
  37, 77, 0, 66, 52, 15, 1, 76, 36, 21, 63, 48, 60, 27, 46, 56, 68, 50, 47, 55,
  78, 69, 74, 20, 54, 14, 53, 82, 71, 11, 30, 72, 13, 40, 32, 22, 10, 31, 42,
  49, 6, 5, 43, 44, 65, 80, 17, 73, 84, 7, 57, 18, 51, 81, 64, 3, 8, 85, 16, 79,
  12, 34, 62, 38, 83, 58, 41, 23, 70, 61, 35, 29, 39, 24, 59, 4, 75, 25, 19, 45, 2, 33, 67, 26, 9, 28,
  37, 77, 0, 66, 52, 15, 1, 76, 36, 21, 63, 48, 60, 27, 46, 56, 68, 50, 47, 55,
  78, 69, 74, 20, 54, 14, 53, 82, 71, 11, 30, 72, 13, 40, 32, 22, 10, 31, 42,
  49, 6, 5, 43, 44, 65, 80, 17, 73, 84, 7, 57, 18, 51, 81, 64, 3, 8, 85, 16, 79,
  12, 34, 62, 38, 83, 58,
];
// 159 in array as of 12.04
export const TRIVIA_MAP = [
  141, 41, 38, 70, 5, 31, 19, 133, 121, 37, 3, 58, 89, 129, 49, 81, 79, 92, 20,
  62, 24, 114, 21, 61, 68, 16, 103, 140, 9, 15, 72, 107, 64, 76, 52, 48, 119,
  78, 27, 63, 39, 0, 44, 98, 87, 109, 50, 143, 96, 28, 36, 35, 90, 154, 148, 86,
  118, 73, 71, 83, 85, 54, 8, 131, 135, 115, 137, 130, 127, 97, 59, 77, 105, 17,
  60, 30, 57, 128, 42, 22, 56, 1, 112, 146, 94, 101, 142, 18, 34, 126, 100, 12,
  93, 6, 88, 102, 46, 116, 125, 33, 134, 136, 47, 145, 10, 124, 51, 104, 144,
  45, 14, 139, 82, 123, 11, 25, 4, 65, 80, 23, 117, 75, 32, 55, 26, 66, 40, 138,
  29, 7, 111, 69, 152, 113, 158, 132, 91, 122, 156, 2, 147, 99, 106, 120, 43,
  74, 84, 13, 53, 149, 110, 67, 108, 95, 117, 64, 72, 130, 22, 81, 136, 93, 58,
  48, 10, 144, 18, 41, 122, 78, 68, 80, 70, 62, 19, 5, 25, 151, 139, 49, 89,
  155, 33, 102, 17, 46, 88, 42, 100, 11, 126, 59, 3, 101, 103, 123, 40, 52, 69,
  109, 51, 150, 54, 106, 65, 85, 26, 0, 132, 23, 94, 2, 75, 134, 99, 143, 6, 35,
  16, 141, 110, 112, 39, 137, 157, 92, 125, 111, 7, 32, 133, 50, 73, 38, 66,
  104, 153, 67, 120, 37, 135, 131, 86, 128, 47, 28, 114, 53, 14, 57, 34, 13,
  107, 127, 90, 61, 96, 31, 56, 124, 71, 8, 1, 118, 129, 97, 63, 77, 108, 121,
  115, 30, 83, 145, 20, 45, 60, 15, 43, 21, 82, 142, 105, 9, 95, 116, 140, 74,
  87, 76, 91, 12, 119, 4, 55, 98, 24, 79, 138, 36, 84, 113, 27, 44,
];
// 553 in array as of 11.04
export const CRAFTS_MAP = [
  139, 337, 542, 513, 68, 57, 312, 163, 67, 14, 181, 146, 528, 170, 80, 38, 501,
   467, 492, 551, 317, 481, 543, 419, 130, 417, 101, 522, 251, 74, 104, 180, 363,
  140, 168, 232, 398, 109, 54, 116, 463, 331, 276, 402, 197, 302, 60, 158, 372,
  120, 188, 515, 341, 446, 248, 338, 176, 222, 85, 41, 451, 165, 243, 488, 429,
  31, 185, 27, 205, 328, 442, 92, 17, 257, 498, 395, 289, 280, 477, 424, 455,
  131, 183, 409, 357, 247, 118, 427, 435, 393, 97, 259, 290, 241, 12, 303, 452,
  321, 65, 416, 37, 315, 458, 274, 115, 454, 535, 352, 42, 210, 125, 133, 63,
  399, 119, 332, 90, 7, 242, 198, 518, 410, 87, 169, 449, 472, 426, 47, 348,
  325, 258, 520, 503, 333, 244, 225, 49, 100, 9, 292, 493, 219, 421, 387, 44,
  404, 272, 24, 45, 122, 536, 103, 160, 479, 537, 487, 470, 547, 368, 546, 144,
  148, 83, 112, 226, 23, 353, 320, 34, 128, 278, 386, 22, 283, 319, 32, 484,
  507, 171, 268, 265, 550, 200, 195, 253, 275, 439, 117, 294, 28, 356, 209, 323,
  471, 291, 480, 8, 330, 539, 482, 182, 453, 145, 517, 336, 141, 516, 293, 3,
  359, 361, 286, 11, 216, 18, 461, 306, 193, 443, 329, 448, 156, 349, 534, 414,
  343, 217, 71, 381, 240, 415, 314, 500, 129, 194, 322, 447, 255, 508, 299, 136,
  370, 366, 382, 511, 137, 441, 189, 228, 6, 384, 475, 378, 218, 184, 199, 301,
  124, 311, 385, 77, 98, 345, 84, 105, 307, 433, 113, 58, 485, 374, 405, 264,
  157, 177, 476, 250, 533, 94, 55, 459, 138, 450, 456, 422, 256, 174, 391, 335,
  72, 159, 364, 212, 147, 469, 524, 436, 412, 549, 62, 30, 223, 350, 538, 313,
    383, 102, 211, 99, 186, 48, 502, 403, 468, 61, 326, 552, 220, 504, 135, 490,
  187, 82, 432, 203, 179, 425, 438, 236, 509, 50, 369, 358, 178, 273, 64, 497,
  375, 510, 397, 164, 224, 420, 52, 390, 428, 10, 380, 309, 166, 190, 499, 206,
  26, 521, 285, 396, 1, 16, 526, 154, 36, 70, 39, 53, 246, 281, 527, 413, 347,
  548, 35, 21, 519, 249, 365, 261, 215, 19, 114, 277, 327, 284, 318, 354, 89,
  175, 523, 2, 530, 167, 96, 237, 126, 269, 367, 545, 279, 305, 324, 91, 339,
  407, 282, 192, 418, 486, 29, 342, 310, 377, 505, 392, 173, 334, 483, 13, 59,
  239, 430, 495, 252, 5, 191, 529, 466, 231, 143, 111, 238, 69, 88, 108, 514,
  20, 132, 79, 121, 473, 444, 478, 152, 271, 230, 229, 172, 150, 287, 202, 233,
  388, 234, 208, 4, 460, 149, 296, 151, 153, 66, 300, 56, 362, 214, 540, 465,
  494, 162, 340, 221, 400, 532, 95, 298, 201, 196, 379, 401, 266, 297, 15, 351,
  496, 86, 394, 431, 445, 207, 346, 525, 110, 464, 423, 406, 437, 512, 25, 344,
  440, 204, 531, 541, 134, 308, 408, 376, 51, 389, 245, 260, 0, 76, 355, 33, 93,
  107, 78, 43, 123, 474, 411, 235, 227, 491, 73, 489, 142, 360, 161, 127, 106,
  373, 267, 75, 457, 544, 288, 316, 213, 295, 254, 81, 263, 46, 262, 434, 506,
  304, 371, 155, 462, 270, 40,
];
// 277 in array as of 18.04
export const SILHOUETTES_MAP = [
  20, 102, 39, 36, 94, 0, 92, 62, 5, 99, 190, 82, 174, 35, 87, 179, 172, 184,
  133, 93, 162, 15, 4, 247, 16, 256, 70, 275, 82, 68, 180, 216, 239, 215, 0,
  108, 179, 56, 11, 166, 252, 67, 33, 190, 123, 105, 160, 269, 240, 17, 22, 193,
  212, 126, 222, 261, 266, 127, 164, 245, 72, 189, 78, 25, 249, 170, 133, 111,
  198, 264, 2, 176, 27, 119, 83, 106, 268, 128, 138, 99, 262, 242, 267, 248,
  161, 113, 165, 81, 29, 24, 228, 172, 244, 276, 12, 163, 44, 48, 137, 71, 109,
  257, 37, 125, 74, 231, 202, 210, 97, 196, 192, 62, 227, 61, 115, 132, 65, 94,
  54, 107, 18, 250, 80, 139, 219, 154, 238, 152, 146, 118, 188, 270, 110, 236,
  60, 85, 50, 175, 58, 90, 120, 3, 92, 6, 20, 258, 131, 14, 69, 194, 98, 35,
  251, 19, 134, 101, 40, 153, 186, 136, 57, 5, 217, 142, 102, 130, 52, 38, 100,
  159, 39, 235, 168, 144, 255, 122, 140, 214, 41, 87, 103, 31, 149, 230, 157, 1,
  155, 265, 177, 254, 178, 129, 51, 143, 274, 96, 86, 199, 259, 104, 79, 9, 124,
  13, 213, 26, 156, 204, 187, 246, 273, 34, 205, 173, 147, 36, 114, 225, 183,
  191, 158, 141, 150, 151, 237, 63, 182, 207, 211, 21, 197, 135, 49, 260, 42,
  76, 220, 23, 229, 121, 59, 45, 148, 272, 208, 203, 224, 174, 64, 271, 112,
  185, 43, 243, 117, 91, 169, 206, 195, 10, 181, 8, 55, 209, 32, 232, 167, 47,
  28, 234, 84, 7, 241, 46, 77, 221, 75, 226, 223, 88, 73, 184, 30, 263, 66, 89,
  116, 171, 145, 253, 218, 95, 53, 233, 237, 198, 49, 165, 82, 103, 16, 229, 59,
  3, 204, 239, 212, 197, 182, 90, 265, 139, 275, 249, 4, 192, 167, 169, 261,
  259, 8, 99, 66, 199, 100, 218, 173, 120, 104, 196, 68, 189, 184, 155, 64, 17,
  250, 105, 172, 58, 81, 222, 76, 213, 88, 248, 41, 157, 256, 57, 69, 135, 63,
  228, 32, 79, 122, 232, 121, 252, 143, 92, 26, 87, 74, 85, 164, 84, 175, 216,
  129, 86, 2, 215, 247, 56, 124, 29, 35, 83, 39, 242, 210, 111, 221, 170, 217,
  268, 148, 153, 181, 116, 70, 77, 154, 52, 109, 61, 150, 102, 260, 107, 190,
  15, 89, 50, 71, 254, 224, 14, 149, 141, 223, 244, 25, 211, 133, 186, 205, 54,
  238, 131, 243, 42, 255, 138, 187, 130, 33, 234, 115, 60, 53, 134, 72, 119,
  241, 235, 51, 136, 40, 80, 246, 270, 168, 209, 37, 30, 145, 132, 20, 67, 174,
  21, 231, 191, 240, 123, 227, 208, 112, 45, 46, 38, 137, 219, 55, 31, 127, 146,
  27, 188, 258, 230, 110, 214, 267, 101, 1, 44, 183, 140, 203, 11, 9, 97, 43,
  151, 144, 207, 106, 236, 220, 93, 271, 152, 274, 48, 117, 233, 194, 162, 126,
  253, 251, 73, 257, 179, 6, 178, 226, 91, 195, 180, 96, 163, 193, 0, 147, 13,
  28, 95, 206, 114, 202, 36, 23, 160, 22, 177, 62, 225, 269, 7, 94, 264, 245,
  176, 118, 161, 98, 142, 262, 273, 185, 266, 171, 263, 166, 19, 10, 24, 47,
  156, 159, 75, 128, 125, 276, 5, 158, 18, 12, 272, 34, 113, 78, 65, 108,
];
